import FlashLib from "flashlib";
import RelaxModel from "../model/RelaxModel";
import EntryPoint from "../../../../engine/src/EntryPoint";

export default class BasePaytableRulesContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
    }

    init() {
        this.text = this.getChildAt(0);
        /*this.linkedArea = this.getChildAt(1);
        this.linkedArea.alpha = 0;
        this.linkedArea.interactive = true;
        this.linkedArea.buttonMode = true;
        this.linkedArea.y = this.text.origHeight - (this.linkedArea.height + 20);
        this.linkedArea.on('pointertap', ()=>{
            let url = `https://api.relaxg.net/capi/1.0/casino/replay/getreplay?replaytoken=${RelaxModel.replaytoken}&gameid=${RelaxModel.gameId}&lang=${RelaxModel.lang}`;
            window.open(url, '_blank');
        });*/

        this.linkedText = this.getChildByName('rules_text_2');
        this.linkedText.interactive = true;
        this.linkedText.buttonMode = true;
        this.linkedText.on('pointertap', this.onLinkClick, this);

        this.linkedText.y = this.text.y + this.text.origHeight;

        let outline = new PIXI.Graphics();
        outline.lineStyle(2, 0xFFFFFF);
        outline.moveTo(0, 0);
        outline.lineTo(this.linkedText.origWidth, 0);
        outline.x = this.linkedText.x;
        outline.y = this.linkedText.y + this.linkedText.origHeight;
        this.addChild(outline);
    }

    onLinkClick() {
        EntryPoint.PostMessages && EntryPoint.PostMessages.onShowHistory();
        let url = `${RelaxModel.gameReplayServiceURL}?replaytoken=${RelaxModel.replaytoken}&gameid=${RelaxModel.gameId}&lang=${RelaxModel.lang}`;
        window.open(url, '_blank');
    }

    addListeners() {

    }

    get height() {
        return super.height + 50;
    }
    set height(value) {
        super.height = value;
    }
}